import styled from 'styled-components';
import { DragDropArea } from 'components/primitives/drag-drop-area';

export const DragDropStyled = styled(DragDropArea)`
  width: 49%;
  padding: ${(p) => (p.small ? 0 : '50px')} 32px;
`;
